import { useAuth0 } from "@auth0/auth0-react";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import * as Sentry from "@sentry/react";
import { Route, Routes } from "react-router-dom";
import { useTheme } from "./context/themeContext";
import "./index.css";

import Login from "./pages/login";
import Onboarding from "./pages/onboarding";
import Signup from "./pages/signup";

import AboutEdit from "./pages/profileView/aboutMe/aboutEdit";
import HelpWithClassification from "./pages/profileView/feedback/helpWithClassificaton";
import MakeLynxBetter from "./pages/profileView/feedback/makeLynxBetter";
import Profile from "./pages/profileView/profile";

import SkillDetails from "./pages/profileView/my-skills/components/skill-details";

import Discover from "./pages/discover";
import SearchResult from "./pages/discover/results";

import EditProject from "./pages/projects-view/edit-project";
import JoinAProject from "./pages/projects-view/join-project";
import ProjectDetails from "./pages/projects-view/join-project/components/project-details";
import ProjectLanding from "./pages/projects-view/landing";
import ProjectManage from "./pages/projects-view/manage-project";
import BoardSubmitionForm from "./pages/projects-view/post-project/board-submission-form";

import Settings from "./pages/settings";
import EmailPreferences from "./pages/settings/email-preferences";
import UserRatings from "./pages/settings/user-ratings";

import PublicProfileView from "./pages/public-profile-view";

import BottomNavBar from "./components/footer";
import HomeFooter from "./components/home-footer";
import AboutMe from "./pages/profileView/aboutMe";
import MySkills from "./pages/profileView/my-skills";
import Projects from "./pages/profileView/projects";
import Applications from "./pages/profileView/projects/components/applications";
import Hosted from "./pages/profileView/projects/components/hosted";
import Liked from "./pages/profileView/projects/components/liked";
import ShoutOuts from "./pages/profileView/shout-outs";
import Given from "./pages/profileView/shout-outs/components/text/components/given";
import Received from "./pages/profileView/shout-outs/components/text/components/received";

function App() {
	const { isLoading, error } = useAuth0();
	const { theme, darkMode } = useTheme();

	return (
		<main
			className="column"
			style={{
				backgroundColor: darkMode ? "#fff" : "#040d12",
			}}
		>
			<Box
				className="app"
				sx={{
					width: {
						xs: "100%",
						md: "400px",
					},
				}}
			>
				<ThemeProvider theme={theme}>
					<CssBaseline />
					{!error && !isLoading && (
						<>
							<Routes>
								<Route path="/" element={<Login />} />
								<Route path="signup" element={<Signup />} />
								<Route
									path="onboarding"
									element={<Onboarding />}
								/>

								<Route path="profile" element={<Profile />}>
									<Route path="about" element={<AboutMe />} />
									<Route
										path="skills"
										element={<MySkills />}
									/>

									<Route
										path="projects"
										element={<Projects />}
									>
										<Route
											path="hosted"
											element={<Hosted />}
										/>
										<Route
											path="applications"
											element={<Applications />}
										/>
										<Route
											path="liked"
											element={<Liked />}
										/>
										<Route path="*" element={<Hosted />} />
									</Route>

									<Route
										path="shoutouts"
										element={<ShoutOuts />}
									>
										<Route
											path="received"
											element={<Received />}
										/>
										<Route
											path="given"
											element={<Given />}
										/>
										<Route
											path="*"
											element={<Received />}
										/>
									</Route>
								</Route>

								<Route
									path="about-edit"
									element={<AboutEdit />}
								/>
								<Route
									path="make-lynx-better"
									element={<MakeLynxBetter />}
								/>
								<Route
									path="help-with-classification"
									element={<HelpWithClassification />}
								/>

								<Route
									path="edit-skill/:id"
									element={<SkillDetails />}
								/>
								<Route
									path="add-skill"
									element={<SkillDetails />}
								/>

								<Route path="discover" element={<Discover />} />
								<Route
									path="discover/results"
									element={<SearchResult />}
								/>

								<Route
									path="projects"
									element={<ProjectLanding />}
								/>
								<Route
									path="project-board-submission"
									element={<BoardSubmitionForm />}
								/>
								<Route
									path="project-join"
									element={<JoinAProject />}
								/>
								<Route
									path="project-manage"
									element={<ProjectManage />}
								/>
								<Route
									path="projects/:id"
									element={<ProjectDetails />}
								/>
								<Route
									path="projects/:id/edit"
									element={<EditProject />}
								/>

								<Route path="settings" element={<Settings />} />
								<Route
									path="user-ratings"
									element={<UserRatings />}
								/>
								<Route
									path="email-preferences"
									element={<EmailPreferences />}
								/>

								<Route
									path="creators/:id"
									element={<PublicProfileView />}
								/>

								<Route
									path="*"
									element={<h1>404 Page not found</h1>}
								/>
							</Routes>

							<BottomNavBar />
							<HomeFooter />
						</>
					)}
				</ThemeProvider>
			</Box>
		</main>
	);
}

export default Sentry.withProfiler(App);

// test commit
